import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LandscapeTypeResponseDto } from '../dto/landscape-type-response.dto';
import typeService from '../services/type.service';

const initialState = {
  status: 'idle',
  landscapeTypes: [] as LandscapeTypeResponseDto[] | null,
  landscapeType: {} as LandscapeTypeResponseDto | null,
  error: null as string | null,
};

export const fetchTypes = createAsyncThunk('types/fetchTypes', async () => {
  return await typeService.fetchTypes();
});

// export const fetchTypeById = createAsyncThunk(
//   'types/fetchTypeById',
//   async (params: { id: string; language: LocalesLanguagesConstants }) => {
//     return await typeService.fetchTypeById(params.id, params.language);
//   }
// );

// export const saveType = createAsyncThunk(
//   'types/saveType',
//   async (params: {
//     saveRequest: LandscapeTypeSaveRequestDto;
//     language: LocalesLanguagesConstants;
//   }) => {
//     return await typeService.saveType(params.saveRequest, params.language);
//   }
// );

// export const updateType = createAsyncThunk(
//   'types/updateType',
//   async (params: {
//     id: string;
//     updateRequest: LandscapeTypeSaveRequestDto;
//     language: LocalesLanguagesConstants;
//   }) => {
//     return await typeService.updateType(
//       params.id,
//       params.updateRequest,
//       params.language
//     );
//   }
// );

// export const deleteType = createAsyncThunk(
//   'types/deleteType',
//   async (existingId: string, { rejectWithValue, dispatch }) => {
//     try {
//       await typeService.deleteType(existingId);
//       dispatch(fetchTypes());
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

const typeSlice = createSlice({
  name: 'typeSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTypes.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTypes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.landscapeTypes = action.payload;
      })
      .addCase(fetchTypes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
    // .addCase(fetchTypeById.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(fetchTypeById.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   state.landscapeType = action.payload;
    // })
    // .addCase(fetchTypeById.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error?.message ?? null;
    // })
    // .addCase(saveType.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(saveType.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   state.landscapeTypes?.push(action.payload);
    //   showSuccess('Type added successfully.');
    // })
    // .addCase(saveType.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error?.message ?? null;
    // });
    // .addCase(updateType.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(updateType.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   if (state.landscapeTypes) {
    //     const typeIndex = state.landscapeTypes.findIndex(
    //       (type) => type.id === action.payload.id
    //     );
    //     if (typeIndex !== -1) {
    //       state.landscapeTypes[typeIndex] = action.payload;
    //     }
    //   }
    // })
    // .addCase(updateType.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error?.message ?? null;
    // });
    // .addCase(deleteType.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(deleteType.fulfilled, (state) => {
    //   state.status = 'succeeded';
    //   showSuccess('Type deleted successfully.');
    // })
    // .addCase(deleteType.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error?.message ?? null;
    //   showError(`Delete type failed. ${action.payload as string}`);
    // });
  },
});

export default typeSlice.reducer;
